module.exports = __webpack_public_path__ + "static/media/columbia.415611a1.png";